import React from 'react';
import SiteFooterView from './SiteFooterView';

function SiteFooter() {
  const props = {};
  return <SiteFooterView {...props} />;
}

export default SiteFooter;
